module.exports = __webpack_public_path__ + "static/media/adLeads_preview.61e77386.PNG";